import Email from "@/domain/entities/emails/Email";
import EmailAttachment from "@/domain/entities/emails/EmailAttachement";

// Le SDK interprète une liste de PJ vide comme « retirer les PJ d'origine ».
export type ForwardAttachments =
    | { ready: false }
    | { ready: true; attachments: EmailAttachment[] };

// Les images du corps sont déjà portées par la copie serveur du transfert : les renvoyer les
// recrée en pièces jointes ordinaires et vides.
export const forwardAttachments = (
    mail: Email,
    sourceCopy?: Email,
): ForwardAttachments => {
    if (!mail.hasAttachment) {
        return { ready: true, attachments: [] };
    }
    if (!sourceCopy) {
        return { ready: false };
    }
    if (!sourceCopy.hasAttachment) {
        return { ready: true, attachments: [] };
    }
    if (sourceCopy.attachments.length === 0) {
        return { ready: false };
    }

    return {
        ready: true,
        attachments: sourceCopy.attachments.filter(
            (attachment) => !attachment.isEmbeddedInBody(),
        ),
    };
};
